import { Reveal } from '@/components/Reveal';
import { TextReveal } from '@/components/TextReveal';

export const PageHero = ({ kicker, title, subtitle, backgroundImage, backgroundVideo, height = 'min-h-[52vh] lg:min-h-[58vh]', children }) => {
  return (
    <section className={`relative ${height} flex items-end lxra-grain overflow-hidden`} data-testid="page-hero-section">
      <div className="absolute inset-0">
        {backgroundVideo ? (
          <video
            className="h-full w-full object-cover"
            src={backgroundVideo}
            poster={backgroundImage}
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
            data-testid="page-hero-background-video"
          />
        ) : (
          <img src={backgroundImage} alt="" className="h-full w-full object-cover" loading="eager" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/50 to-[#0A0A0A]/40" />
      </div>
      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-10 pb-14 pt-32">
        <Reveal>
          {kicker && (
            <p className="text-xs sm:text-sm tracking-[0.22em] uppercase text-[hsl(var(--lxra-gold))] mb-3">{kicker}</p>
          )}
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-[0.04em] leading-[0.95] text-[hsl(var(--lxra-fg))]">
            <TextReveal text={title} />
          </h1>
          <div className="mt-4 h-[2px] w-16 bg-[hsl(var(--lxra-gold))]" />
          {subtitle && (
            <p className="mt-5 max-w-xl text-sm sm:text-base text-[hsl(var(--lxra-muted))] leading-relaxed">{subtitle}</p>
          )}
          {children}
        </Reveal>
      </div>
    </section>
  );
};
